"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateTheme = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _index = require("./helpers//index");
var _ykbUtils = require("ykb-utils");
var mixins = _interopRequireWildcard(require("./mixins"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var generateTheme = exports.generateTheme = function generateTheme(tokens) {
  var border = {
    width: '1px',
    style: 'solid',
    colorBase: tokens.color.default6,
    // gray6
    colorSplit: tokens.color.neutral6
  };
  var component = {
    color: tokens.color.default6,
    background: tokens.color.neutral1,
    padding: tokens.component.padding,
    borderRadius: '4px',
    shadow: "0 1px 6px ".concat(tokens.shadow.color)
  };
  var shadow = {
    color: tokens.shadow.color,
    base: "0 1px 6px ".concat(tokens.shadow.color),
    up: "0 -1px 6px ".concat(tokens.shadow.color),
    down: "0 1px 6px ".concat(tokens.shadow.color),
    left: "-1px 0 6px ".concat(tokens.shadow.color),
    right: "1px 0 6px ".concat(tokens.shadow.color),
    secondary: "0 2px 8px ".concat(tokens.shadow.color)
  };
  var button = {
    borderWidth: border.width,
    borderStyle: border.style,
    borderRadius: '4px',
    tabfocuscolor: tokens.color.primary4,
    focusBoxShadow: '0 0 3px 3px ' + tokens.color.primary3,
    // Common variables
    marginDefault: '0px',
    marginRight: tokens.component.padding,
    padding: "0 15px",
    //degiskene baglansin
    fontSize: tokens.font.size,
    fontWeight: 400,
    height: tokens.component.height,
    iconSize: '24px',
    paddingWithIcons: tokens.button.size.medium.paddingWithIcons,
    size: {
      xsmall: {
        padding: '0 8px',
        height: tokens.component.heightXs,
        fontSize: tokens.font.sizeSm,
        borderWidth: '0.8px',
        iconSize: '16px',
        paddingWithIcons: tokens.button.size.xsmall.paddingWithIcons
      },
      small: {
        padding: '0 10px',
        fontSize: tokens.font.sizeSm,
        fontWeight: 400,
        height: tokens.component.heightSm,
        iconSize: '20px',
        paddingWithIcons: tokens.button.size.small.paddingWithIcons
      },
      large: {
        padding: '0 20px',
        fontSize: tokens.font.sizeLg,
        fontWeight: 400,
        height: tokens.component.heightLg,
        iconSize: '26px',
        paddingWithIcons: tokens.button.size.large.paddingWithIcons
      }
    },
    disabled: {
      backgroundColor: tokens.color.default1
    },
    type: {
      primary: {
        textColor: tokens.color.neutral1,
        textColorHover: tokens.color.neutral1,
        textColorPressed: tokens.color.neutral1,
        textColorDisabled: tokens.color.neutral1,
        backgroundColor: tokens.color.primary6,
        backgroundColorHover: tokens.color.primary7,
        // TODO is press color same as hover?
        backgroundColorPressed: tokens.color.primary8,
        backgroundColorDisabled: tokens.color.primary4,
        borderColor: tokens.color.primary6,
        borderColorHover: tokens.color.primary7,
        borderColorPressed: tokens.color.primary8,
        borderColorDisabled: tokens.color.primary4
      },
      secondary: {
        textColor: tokens.color.primary6,
        textColorHover: tokens.color.primary7,
        textColorPressed: tokens.color.primary8,
        textColorDisabled: tokens.color.primary4,
        backgroundColor: tokens.color.neutral1,
        backgroundColorHover: tokens.color.primary1,
        backgroundColorPressed: tokens.color.primary2,
        backgroundColorDisabled: tokens.color.neutral1,
        borderColor: tokens.color.primary6,
        borderColorHover: tokens.color.primary7,
        borderColorPressed: tokens.color.primary8,
        borderColorDisabled: tokens.color.primary4
      },
      danger: {
        textColor: tokens.color.neutral1,
        textColorHover: tokens.color.neutral1,
        textColorPressed: tokens.color.neutral1,
        textColorDisabled: tokens.color.neutral1,
        backgroundColor: tokens.color.danger6,
        backgroundColorHover: tokens.color.danger7,
        backgroundColorPressed: tokens.color.danger8,
        backgroundColorDisabled: tokens.color.danger4,
        borderColor: tokens.color.danger6,
        borderColorHover: tokens.color.danger7,
        borderColorPressed: tokens.color.danger8,
        borderColorDisabled: tokens.color.danger4
      },
      success: {
        textColor: tokens.color.neutral1,
        textColorHover: tokens.color.neutral1,
        textColorPressed: tokens.color.neutral1,
        textColorDisabled: tokens.color.neutral1,
        backgroundColor: tokens.color.success6,
        backgroundColorHover: tokens.color.success7,
        backgroundColorPressed: tokens.color.success8,
        backgroundColorDisabled: tokens.color.success4,
        borderColor: tokens.color.success6,
        borderColorHover: tokens.color.success7,
        borderColorPressed: tokens.color.success8,
        borderColorDisabled: tokens.color.success4
      },
      default: {
        textColor: tokens.color.neutral1,
        textColorHover: tokens.color.neutral1,
        textColorPressed: tokens.color.neutral1,
        textColorDisabled: tokens.color.neutral1,
        backgroundColor: tokens.color.default7,
        backgroundColorHover: tokens.color.default8,
        backgroundColorPressed: tokens.color.default9,
        backgroundColorDisabled: tokens.color.default4,
        borderColor: tokens.color.default7,
        borderColorHover: tokens.color.default8,
        borderColorPressed: tokens.color.default9,
        borderColorDisabled: tokens.color.default4
      },
      ghost: {
        padding: '0 5px',
        margin: 0,
        border: '0 none',
        backgroundColor: 'transparent'
        // TODO: check ghost hover press
        // Değişkenleri transparent ekle.
        // proje özelinde değişebilir
        // color neutral 11
      },
      link: {
        padding: '0px',
        margin: 0,
        fontWeight: 400,
        backgroundColor: 'transparent',
        textColor: tokens.color.primary6,
        textColorHover: tokens.color.primary7,
        textColorPressed: tokens.color.primary8,
        textColorDisabled: tokens.color.primary4,
        textDecoration: 'none',
        textHoverDecoration: 'underline' //degiskene bagliydi ama gerek yok sanirim @link-hover-decoration
      }
    }
  };
  var icon = {
    boxShadow: "0 0 3px 3px ".concat((0, _index.convertHexToRGBA)(tokens.color.primary3, 0.95)),
    borderRadius: tokens.borderRadiusBase,
    type: {
      default: {
        color: tokens.color.default6,
        hoverColor: tokens.color.default7,
        hoverBackgroundColor: tokens.color.default2,
        focusColor: tokens.color.default7,
        focusBackgroundColor: tokens.color.default2,
        pressedColor: tokens.color.default8,
        pressedBackgroundColor: tokens.color.default3,
        disabledColor: tokens.color.default4
      },
      primary: {
        color: tokens.color.primary6,
        hoverColor: tokens.color.primary7,
        hoverBackgroundColor: tokens.color.default2,
        focusColor: tokens.color.primary7,
        focusBackgroundColor: tokens.color.default2,
        pressedColor: tokens.color.primary8,
        pressedBackgroundColor: tokens.color.default3,
        disabledColor: tokens.color.primary4
      },
      secondary: {
        color: tokens.color.secondary6,
        hoverColor: tokens.color.secondary7,
        hoverBackgroundColor: tokens.color.default2,
        focusColor: tokens.color.secondary7,
        focusBackgroundColor: tokens.color.default2,
        pressedColor: tokens.color.secondary8,
        pressedBackgroundColor: tokens.color.default3,
        disabledColor: tokens.color.secondary4
      },
      success: {
        color: tokens.color.success6,
        hoverColor: tokens.color.success7,
        hoverBackgroundColor: tokens.color.default2,
        focusColor: tokens.color.success7,
        focusBackgroundColor: tokens.color.default2,
        pressedColor: tokens.color.success8,
        pressedBackgroundColor: tokens.color.default3,
        disabledColor: tokens.color.success4
      },
      warning: {
        color: tokens.color.warning6,
        hoverColor: tokens.color.warning7,
        hoverBackgroundColor: tokens.color.default2,
        focusColor: tokens.color.warning7,
        focusBackgroundColor: tokens.color.default2,
        pressedColor: tokens.color.warning8,
        pressedBackgroundColor: tokens.color.default3,
        disabledColor: tokens.color.warning4
      },
      danger: {
        color: tokens.color.danger6,
        hoverColor: tokens.color.danger7,
        hoverBackgroundColor: tokens.color.default2,
        focusColor: tokens.color.danger7,
        focusBackgroundColor: tokens.color.default2,
        pressedColor: tokens.color.danger8,
        pressedBackgroundColor: tokens.color.default3,
        disabledColor: tokens.color.danger4
      }
    },
    size: {
      xsmall: {
        fontSize: '12px'
      },
      small: {
        fontSize: '16px'
      },
      medium: {
        fontSize: '24px'
      },
      large: {
        fontSize: '32px'
      }
    }
  };
  var text = {
    color: tokens.color.neutral11,
    colorSecondary: tokens.color.neutral7,
    colorDisabled: tokens.color.neutral7,
    placeHolderTextColor: tokens.color.neutral7
  };
  var animation = {
    ease: {
      out: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
      in: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
      inOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
      outBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
      inBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
      inOutBack: 'cubic-bezier(0.71, -0.46, 0.29, 1.46)',
      outCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
      inCirc: 'cubic-bezier(0.6, 0.04, 0.98, 0.34)',
      inOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
      outQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
      inQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
      inOutQuint: 'cubic-bezier(0.86, 0, 0.07, 1)'
    },
    base: {
      duration: '0.2s'
    },
    slow: {
      duration: '0.3s'
    },
    fast: {
      duration: '0.1s'
    }
  };
  var divider = {
    textColor: text.color,
    backgroundColor: tokens.color.default4,
    // grey4
    borderColor: tokens.color.default4,
    // grey4
    vertical: {
      fontSize: tokens.font.size,
      width: '1px',
      height: '0.9em'
    },
    horizontal: {
      fontSize: tokens.font.sizeLg,
      width: '100%',
      height: '1px'
    },
    margin: '8px'
  };
  var list = {
    sizes: {
      small: {
        padding: '8px 15px'
      },
      medium: {
        padding: '12px 15px'
      },
      large: {
        padding: '16px 15px'
      }
    },
    borderColor: border.colorBase,
    textColor: text.color,
    backgroundColor: tokens.color.default1
  };
  var card = {
    head: {
      height: '44px',
      textColor: text.color,
      backgroundColor: component.background,
      borderColor: border.colorBase,
      selectedBorderColor: tokens.color.primary6,
      padding: "0 15px",
      borderRadius: "4px 4px  0 0",
      titleFontSize: tokens.font.size
    },
    body: {
      padding: '15px',
      icon: {
        color: tokens.color.primary6,
        size: tokens.iconSizeBase
      },
      borderColorPadding: '30px 20px'
    },
    card: {
      padding: '0',
      backgroundColor: component.background,
      borderRadius: '4px',
      fontSize: tokens.font.size,
      hover: {
        boxShadow: shadow.down
      },
      bordered: {
        border: "".concat(border.width, " ").concat(border.style, " ").concat(border.colorBase)
      },
      selected: {
        border: "".concat(border.width, " ").concat(border.style, " ").concat(tokens.color.primary6)
      },
      borderColor: {
        primary: {
          default: tokens.color.primary6,
          hover: tokens.color.primary7,
          active: tokens.color.primary8
        },
        danger: {
          default: tokens.color.danger6,
          hover: tokens.color.danger7,
          active: tokens.color.danger8
        },
        success: {
          default: tokens.color.success6,
          hover: tokens.color.success7,
          active: tokens.color.success8
        }
      }
    },
    cover: {
      borderRadius: "4px 4px 0 0"
    }
  };
  var modal = {
    // TODO move to tokens as modalPadding - 20px modal padding
    // TODO modal mask bg color
    // TODO zIndex?
    top: '100px',
    margin: tokens.gutter,
    zIndex: tokens.zIndex.modal,
    borderRadius: tokens.modalBorderRadius || tokens.borderRadiusBase,
    iconSize: 64,
    mask: {
      backgroundColor: 'rgba(55, 55, 55, 0.6)',
      zIndex: tokens.zIndex.modalMask
    },
    title: {
      fontSize: tokens.font.sizeLg,
      fontWeight: '500',
      color: tokens.color.neutral12
    },
    content: {
      backgroundColor: component.background
    },
    body: {
      padding: "20px",
      centerPadding: '54px 20px 20px',
      noTitlePadding: '49px 20px 20px'
    },
    header: {
      horizontalPadding: '20px',
      verticalPadding: '15px',
      whenClosableRightPadding: '45px',
      backgroundColor: component.background,
      color: tokens.color.primary5
    },
    footer: {
      padding: '15px 20px',
      centerPadding: '20px'
    },
    close: {
      top: '13px',
      right: '10px',
      color: tokens.color.neutral12
    },
    width: {
      xsmall: '320px',
      small: '480px',
      default: '640px',
      large: '800px',
      xlarge: '1024px',
      maximum: '1650px',
      centered: '320px'
    }
  };
  var spin = {
    color: tokens.color.primary6,
    width: 32,
    bgOpacity: 0.45,
    fontSize: tokens.font.size,
    fontWeight: 400,
    gapPadding: '3px'
  };
  var infoBox = {
    lineHeight: 1.5,
    contentPadding: '10px',
    fontSize: tokens.infoBoxFontSize || tokens.font.size,
    border: {
      width: '1px',
      style: 'solid',
      color: border.colorBase,
      radius: tokens.infoBoxBorderRadius || tokens.borderRadiusBase
    },
    icon: {
      size: tokens.iconSizeBase,
      padding: '10px 0 10px 10px',
      suffixPadding: '10px 10px 10px 0'
    },
    type: {
      default: {
        backgroundColor: tokens.colorPalette.grey1,
        borderColor: border.colorBase,
        iconColor: tokens.colorPalette.grey6,
        textColor: text.color
      },
      info: {
        backgroundColor: tokens.color.info1,
        borderColor: tokens.color.info4,
        iconColor: tokens.color.info6,
        textColor: text.color
      },
      success: {
        backgroundColor: tokens.colorPalette.green1,
        borderColor: tokens.color.success4,
        iconColor: tokens.color.success6,
        textColor: text.color
      },
      warning: {
        backgroundColor: tokens.colorPalette.yellow1,
        borderColor: tokens.color.warning4,
        iconColor: tokens.color.warning6,
        textColor: text.color
      },
      danger: {
        backgroundColor: tokens.colorPalette.red1,
        borderColor: tokens.color.danger4,
        iconColor: tokens.color.danger6,
        textColor: text.color
      }
    },
    ul: {
      margin: '5px 0 0',
      paddingInlineStart: '15px',
      fontSize: '12px'
    }
  };
  var Switch = {
    baseColor: tokens.colorPalette.grey6,
    duration: '0.3s',
    height: {
      small: '16px',
      default: '22px',
      large: '30px'
    },
    minWidth: {
      small: '28px',
      default: '42px',
      large: '58px'
    },
    toogleSize: {
      small: '12px',
      default: '18px',
      large: '26px'
    },
    toogleActiveSize: {
      small: '16px',
      default: '25px',
      large: '38px'
    },
    toogleLeft: {
      small: '13px',
      default: '21px',
      large: '29px'
    },
    toogleActiveLeft: {
      small: '9px',
      default: '14px',
      large: '17px'
    },
    toggleBorderRadius: {
      small: '6px',
      default: '9px',
      large: '13px'
    },
    lineHeight: {
      small: '16px',
      default: '20px',
      large: '30px'
    },
    innerLeft: {
      small: '2px',
      default: '6px',
      large: '10px'
    },
    fontSize: '12px',
    checkColor: tokens.color.primary6,
    toogleBoxShadow: '0 1px 3px 0px rgba(0, 0, 0, 0.05)',
    focusBoxShadow: "0 0 0 2px ".concat(tokens.color.primary3),
    backgroundColor: {
      active: tokens.color.primary6,
      deactive: tokens.colorPalette.grey6,
      focus: tokens.color.primary3,
      press: tokens.color.primary3,
      disable: tokens.color.primary4
    },
    toogleColor: {
      default: tokens.colorPalette.neutral1,
      disable: tokens.color.primary1
    }
  };
  var notification = {
    fontSize: tokens.font.size,
    color: text.color,
    zIndex: tokens.zIndex.notification,
    width: '335px',
    margin: "0 ".concat(tokens.component.padding2x),
    padding: tokens.component.padding,
    shadow: shadow.down,
    borderRadius: tokens.borderRadiusBase,
    iconSize: 24,
    success: {
      backgroundColor: tokens.color.success6,
      textColor: tokens.color.neutral1,
      iconColor: tokens.color.neutral1
    },
    warning: {
      backgroundColor: tokens.color.warning6,
      textColor: tokens.color.neutral1,
      iconColor: tokens.color.neutral1
    },
    error: {
      backgroundColor: tokens.color.danger6,
      textColor: tokens.color.neutral1,
      iconColor: tokens.color.neutral1
    },
    info: {
      backgroundColor: tokens.color.info6,
      textColor: tokens.color.neutral1,
      iconColor: tokens.color.neutral1
    }
  };
  var menu = {
    borderColor: border.colorBase,
    // border.baseColor, // #d9d9d9
    shadow: "0 0 4px #d9d9d9",
    // #d9d9d9
    color: text.color,
    // tokens.color.grey6, // #666
    borderRadius: '4px',
    // base border
    iconSize: 16,
    title: {
      color: tokens.color.default6,
      // tokens.color.grey4,
      borderColor: tokens.color.default6,
      // tokens.color.neutral3, // #dedede
      padding: '8px 8px 8px 24px'
    },
    active: {
      backgroundColor: tokens.color.primary2 // tokens.color.neutral2, // #eaf8fe
    },
    selected: {
      backgroundColor: tokens.color.primary2 // tokens.color.neutral2,
    },
    disabled: {
      color: text.colorDisabled // #777
    },
    divider: {
      backgroundColor: border.colorBase // #e5e5e5;
    },
    sub: {
      minWidth: '160px',
      backgroundColor: tokens.color.neutral1,
      title: {
        padding: '8px 8px 8px 24px'
      }
    },
    horizontal: {
      color: text.color,
      backgroundColor: tokens.color.default1,
      borderColor: tokens.color.default1,
      padding: '15px 20px',
      active: {
        color: tokens.color.primary5,
        backgroundColor: tokens.color.default1,
        borderColor: tokens.color.primary5,
        hoverBackgroundColor: tokens.color.primary2
      }
    },
    vertical: {
      padding: '10px 0',
      titlePadding: '12px 8px 12px 24px',
      arrowRight: '8px'
    }
  };
  var input = {
    iconSize: 24,
    minWidth: '200px',
    backgroundColor: tokens.color.neutral1,
    backgroundColorType: {
      primary: tokens.color.primary1,
      default: tokens.color.neutral1,
      danger: tokens.color.danger1
    },
    borderColor: border.colorBase,
    // grey6
    color: text.color,
    placeHolderColor: text.placeHolderTextColor,
    borderRight: tokens.input.allowClear.borderRight,
    hover: {
      borderColor: tokens.color.primary6
    },
    focus: {
      borderColor: tokens.color.primary6,
      boxShadowColor: (0, _index.convertHexToRGBA)(tokens.color.primary3, 0.95) // rgba(tokens.color.primary, 0.1),
    },
    active: {
      borderColor: tokens.color.primary6,
      boxShadowColor: (0, _index.convertHexToRGBA)(tokens.color.primary3, 0.95) // rgba(tokens.color.primary, 0.1),
    },
    addon: {
      backgroundColor: tokens.color.default1 // colors.defaultLight95,
    },
    disabled: {
      backgroundColor: tokens.color.default1,
      // gray1
      borderColor: tokens.color.default6,
      // gray6
      color: text.colorDisabled,
      // neutral7
      hover: {
        borderColor: tokens.color.default6,
        // colors.defaultLight80,
        boxShadowColor: tokens.color.default1 // rgba(colors.textColorDisabled, 0.1),
      }
    },
    editableCurrency: {
      margin: tokens.input.editableCurrency.margin
    },
    colorType: {
      success: {
        color: tokens.color.success6
      }
    },
    sizes: {
      medium: {
        fontSize: tokens.font.size,
        lineHeight: '1.5em',
        padding: "4px 10px",
        paddingHorizontal: tokens.component.padding,
        paddingVertical: '4px',
        borderRadius: tokens.borderRadiusBase,
        border: "".concat(border.width, " ").concat(border.style, " ").concat(border.colorBase),
        height: tokens.component.height,
        iconMargin: 6,
        editableCurrencyWidth: tokens.input.sizes.medium.editableCurrencyWidt,
        editableCurrencyHeight: tokens.input.sizes.medium.editableCurrencyHeight,
        editableCurrencyFontSize: tokens.input.sizes.medium.editableCurrencyFontSize,
        copyIconSize: tokens.input.sizes.medium.copyIconSize
      },
      small: {
        fontSize: tokens.font.sizeSm,
        lineHeight: '1.5em',
        padding: "1px 8px",
        paddingHorizontal: tokens.component.padding,
        paddingVertical: '1px',
        borderRadius: tokens.borderRadiusBase,
        border: "".concat(border.width, " ").concat(border.style, " ").concat(border.colorBase),
        height: tokens.component.heightSm,
        iconMargin: 5,
        editableCurrencyWidth: tokens.input.sizes.small.editableCurrencyWidt,
        editableCurrencyHeight: tokens.input.sizes.small.editableCurrencyHeight,
        editableCurrencyFontSize: tokens.input.sizes.small.editableCurrencyFontSize,
        copyIconSize: tokens.input.sizes.small.copyIconSize
      },
      large: {
        fontSize: tokens.font.sizeLg,
        lineHeight: '1.5em',
        padding: "6px 10px",
        paddingHorizontal: tokens.component.padding,
        paddingVertical: '6px',
        borderRadius: tokens.borderRadiusBase,
        border: "".concat(border.width, " ").concat(border.style, " ").concat(border.colorBase),
        height: tokens.component.heightLg,
        iconMargin: 8,
        editableCurrencyWidth: tokens.input.sizes.large.editableCurrencyWidt,
        editableCurrencyHeight: tokens.input.sizes.large.editableCurrencyHeight,
        editableCurrencyFontSize: tokens.input.sizes.large.editableCurrencyFontSize,
        copyIconSize: tokens.input.sizes.large.copyIconSize
      }
    },
    phoneInput: {
      dialCodeAddon: {
        width: tokens.input.phoneInput.dialCodeAddon.width
      }
    },
    numberInput: {
      width: tokens.input.numberInput.width
    }
  };
  var typography = {
    color: text.color,
    textColorPressed: tokens.color.primary7,
    textColorDisabled: tokens.color.primary4,
    link: {
      color: tokens.color.primary6,
      hoverColor: tokens.color.primary5,
      pressedColor: tokens.color.primary7,
      hoverDecoration: 'underline',
      iconSize: '20px',
      iconGap: '8px',
      successColor: tokens.color.success6
    },
    colorTypes: {
      success: tokens.color.success6,
      secondary: tokens.color.primary6,
      warning: tokens.color.warning6,
      danger: tokens.color.danger6,
      disabled: tokens.color.neutral4
    },
    paragraph: {
      marginTop: '0px',
      marginBottom: '14px',
      lineHeight: '1.5715'
    },
    title: {
      stackMarginTop: '20px',
      color: text.color,
      level: {
        h1: {
          marginBottom: '10px',
          color: text.color,
          fontWeight: 500,
          fontSize: '36px',
          lineHeight: 1.36
        },
        h2: {
          marginBottom: '10px',
          color: text.color,
          fontWeight: 500,
          fontSize: '30px',
          lineHeight: 1.36666
        },
        h3: {
          marginBottom: '10px',
          color: text.color,
          fontWeight: 500,
          fontSize: '24px',
          lineHeight: 1.375
        },
        h4: {
          marginBottom: '10px',
          color: text.color,
          fontWeight: 500,
          fontSize: '20px',
          lineHeight: 1.35
        },
        h5: {
          marginBottom: '10px',
          color: text.color,
          fontWeight: 500,
          fontSize: '18px',
          lineHeight: 1.333
        },
        h6: {
          marginBottom: '10px',
          color: text.color,
          fontWeight: 500,
          fontSize: '16px',
          lineHeight: 1.375
        }
      }
    },
    text: {
      types: {
        mark: {
          padding: 0,
          background: '#ffe58f'
        },
        code: {
          margin: '0 0.2em',
          padding: '0.2em 0.4em 0.1em',
          fontSize: '85%',
          background: 'rgba(150, 150, 150, 0.1)',
          border: '1px solid rgba(100, 100, 100, 0.2)',
          borderRadius: '3px'
        },
        keyboard: {
          margin: ' 0 0.2em',
          padding: '0.15em 0.4em 0.1em',
          fontSize: '90%',
          background: 'rgba(150, 150, 150, 0.06)',
          border: '1px solid rgba(100, 100, 100, 0.2)',
          borderRadius: '3px'
        },
        underline: {
          textDecoration: 'underline'
        },
        delete: {
          textDecoration: 'line-through'
        },
        strong: {
          fontWeight: '600'
        }
      }
    }
  };
  var textarea = {
    border: "".concat(border.width, " ").concat(border.style, " ").concat(border.colorBase),
    borderRadius: tokens.borderRadiusBase,
    height: '80px',
    width: '100%',
    fontSize: tokens.font.size,
    padding: tokens.component.padding,
    disabled: {
      border: "".concat(border.width, " ").concat(border.style, " ").concat(border.colorBase)
    }
  };
  var tabs = {
    color: text.color,
    marginBottom: '10px',
    animation: animation.ease.inOut,
    border: {
      color: border.colorBase,
      style: border.style,
      width: border.width,
      radius: tokens.borderRadiusBase
    },
    bar: {
      inkLineColor: tokens.color.primary6
    },
    navigation: {
      fontSize: '14px',
      lineHeight: 1.5,
      tabs: {
        marginRight: '24px',
        textDecoration: 'none',
        hoverColor: tokens.color.primary5,
        activeColor: tokens.color.primary6,
        pressedColor: tokens.color.primary7,
        disabledColor: tokens.color.default4,
        closeIcon: {
          fontSize: '16px',
          marginLeft: '5px',
          color: tokens.color.default6,
          hoverColor: tokens.color.default7
        },
        padding: '8px 15px',
        size: {
          small: {
            padding: '8px 16px',
            fontSize: '13px'
          },
          medium: {
            padding: '8px 20px',
            fontSize: '14px'
          },
          large: {
            padding: '8px 24px',
            fontSize: '16px'
          }
        },
        vertical: {
          padding: '8px 24px'
        },
        card: {
          height: '32px',
          color: text.color,
          activeColor: tokens.color.primary6,
          disabledColor: tokens.color.default4,
          backgroundColor: '#f9f9f9',
          activeBackgroundColor: '#fff',
          disabledBackgroundColor: '#f9f9f9'
        }
      },
      arrows: {
        color: text.color,
        hoverColor: tokens.color.neutral11,
        disabledColor: tokens.color.default4,
        iconSize: '16px'
      }
    },
    addTabButton: {
      color: text.color,
      width: '16px',
      height: '16px',
      fontSize: '14px',
      hover: {
        color: tokens.color.primary6,
        borderColor: tokens.color.primary6
      }
    },
    content: {
      padding: '15px'
    }
  };
  var dropdown = {
    border: {
      color: border.colorBase,
      style: border.style,
      width: border.width,
      radius: tokens.borderRadiusBase
    },
    animation: {
      slideUpTimeFunc: animation.ease.outCirc,
      slideUpLeaveTimeFunc: animation.ease.inCirc
    },
    box: {
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      padding: '4px 0px',
      margin: 0,
      textAlign: 'left',
      backgroundColor: '#fff',
      borderTopColor: 'transparent'
    },
    listItem: {
      fontSize: '14px',
      lineHeight: '1.5em',
      padding: '8px 10px',
      fontWeight: 'normal',
      color: text.color,
      backgroundColor: 'transparent',
      hoverColor: tokens.color.neutral11,
      hoverBackgroundColor: tokens.color.default1,
      disabledColor: text.colorDisabled,
      disabledBackgroundColor: 'transparent'
    },
    divider: {
      height: '1px',
      width: '1px 0px',
      backgroundColor: tokens.color.default6
    }
  };
  var steps = {
    tailSize: '1px',
    dotTailSize: '2px',
    background: 'transparent',
    padding: '10px 0px',
    verticalGap: '0px 10px',
    tailColor: tokens.color.default4,
    border: 'none',
    dotWidth: '8px',
    hoverBackgroundColor: tokens.color.primary7,
    customStep: {
      backgroundColor: 'transparent !important',
      borderColor: 'transparent !important'
    },
    iconTitleGap: '6px',
    titleDescriptionGap: '4px',
    verticalStepsSpacing: '20px',
    size: {
      normal: {
        circleSize: 24,
        borderRadius: '100%',
        iconSize: '16px',
        stepNumberSize: '13px',
        titleFontSize: '14px',
        titleLineHeight: '19px',
        descriptionFontSize: '13px',
        descriptionLineHeight: '18px'
      },
      small: {
        circleSize: 16,
        borderRadius: '100%',
        iconSize: '12px',
        stepNumberSize: '11px',
        titleFontSize: '14px',
        titleLineHeight: '19px',
        descriptionFontSize: '13px',
        descriptionLineHeight: '18px'
      }
    },
    status: {
      error: {
        textColor: tokens.colorPalette.red6,
        iconColor: tokens.color.neutral1,
        backgroundColor: tokens.colorPalette.red6,
        borderColor: tokens.colorPalette.red6,
        customIconColor: tokens.colorPalette.red6,
        tailColor: tokens.color.default4,
        titleFontWeight: '500'
      },
      finish: {
        textColor: text.color,
        iconColor: tokens.color.neutral1,
        backgroundColor: tokens.color.primary6,
        borderColor: tokens.color.primary6,
        customIconColor: tokens.color.primary6,
        tailColor: tokens.color.primary6,
        titleFontWeight: '500'
      },
      wait: {
        textColor: tokens.color.neutral7,
        iconColor: tokens.color.neutral1,
        backgroundColor: tokens.color.default4,
        borderColor: tokens.color.default4,
        customIconColor: tokens.color.default4,
        tailColor: tokens.color.default4,
        titleFontWeight: '400'
      },
      process: {
        textColor: text.color,
        iconColor: tokens.color.neutral1,
        backgroundColor: tokens.color.primary6,
        borderColor: tokens.color.primary6,
        customIconColor: tokens.color.primary6,
        tailColor: tokens.color.default4,
        titleFontWeight: '500'
      }
    }
  };
  var tooltip = {
    zIndex: tokens.zIndex.tooltip,
    fontSize: tokens.font.size,
    lineHeight: tokens.font.lineHeight,
    opacity: 1,
    arrowWidth: 6,
    distance: 6 + 4,
    padding: '8px 15px',
    color: tokens.colorPalette.neutral1,
    backgroundColor: tokens.colorPalette.grey9,
    borderRadius: tokens.borderRadiusBase,
    overlayShadow: '0 0 4px rgba(0, 0, 0, 0.17)',
    arrowColor: tokens.colorPalette.grey9,
    bordercolor: tokens.colorPalette.grey9
  };
  var popover = {
    zIndex: tokens.zIndex.tooltip,
    fontSize: tokens.font.size,
    lineHeight: tokens.font.lineHeight,
    opacity: 1,
    arrowWidth: 6,
    distance: 6 + 4,
    padding: '10px 15px',
    color: tokens.colorPalette.neutral11,
    backgroundColor: '#fff',
    borderRadius: tokens.borderRadiusBase,
    overlayShadow: '0px 2px 15px 0px rgba(0,0,0,0.15)',
    arrowColor: '#fff',
    borderColor: tokens.colorPalette.grey4
  };
  var progress = {
    labelText: {
      right: 'calc(0.5em + 28px)',
      left: '0px',
      fontWeight: '400',
      lineHeight: '18px',
      fontSize: '1em'
    },
    paddingRight: 'calc(2em + 8px)',
    marginRight: 'calc(-2em - 8px)',
    remainingColor: tokens.colorPalette.grey1,
    processingColor: tokens.colorPalette.blue6,
    defaultColor: tokens.colorPalette.blue6,
    textColor: text.color,
    activeBackground: component.background,
    errorColor: tokens.color.danger6,
    successColor: tokens.color.success6
  };
  var collapse = {
    backgroundColor: tokens.colorPalette.neutral1,
    disabledBg: tokens.colorPalette.grey2,
    disabledIconColor: tokens.colorPalette.grey6,
    borderColor: {
      default: tokens.colorPalette.grey4,
      primary: tokens.color.primary6,
      danger: tokens.color.danger6,
      success: tokens.color.success6
    },
    border: "".concat(border.width, " ").concat(border.style, " ").concat(tokens.colorPalette.grey4),
    headerHeight: '38px',
    headerColor: text.color,
    horizontalPadding: '10px',
    verticalPadding: '10px',
    arrowColor: tokens.color.primary6,
    boxShadow: "0 0 0 2px rgb(196,228,255)" // TODO
  };
  var pagination = {
    itemSize: tokens.pagination.itemSize,
    itemSizeSm: tokens.pagination.itemSizeSm,
    itemSizeLg: tokens.pagination.itemSizeLg,
    itemColor: tokens.color.neutral7,
    itemHoverColor: tokens.color.primary6,
    itemActiveColor: tokens.color.primary6,
    disabledBorderColor: tokens.color.primary4,
    disabledTextColor: tokens.color.primary4,
    disabledIconColor: tokens.color.primary4,
    smallItemLineHeight: tokens.pagination.lineHeightSm,
    largeItemLineHeight: tokens.pagination.lineHeightLg,
    jumpHeightLg: tokens.pagination.jumpHeightLg,
    miniOptionsSizeChangerTop: '1px',
    itemFontSize: tokens.pagination.fontSize,
    borderColor: tokens.color.default2,
    jumpIconColor: {
      default: tokens.color.primary6,
      hover: tokens.color.primary6
    },
    itemTextColor: {
      default: tokens.color.neutral7,
      hover: tokens.color.primary6,
      press: tokens.color.primary6,
      select: tokens.color.neutral1
    }
  };
  var select = {
    icon: {
      right: "calc(".concat(input.sizes.medium.paddingHorizontal, " - 4px)"),
      rightForSmall: '36px',
      rightForLarge: '56px',
      rightForMedium: '46px',
      size: '24px',
      clearMarginTop: "calc(-".concat(input.sizes.medium.paddingHorizontal, " / 2)")
    },
    addon: {
      fontSize: tokens.select.addon.fontSize,
      padding: tokens.select.addon.padding,
      border: tokens.select.addon.border,
      borderRadiusAfter: tokens.select.addon.after.borderRadius,
      borderRadiusBefore: tokens.select.addon.before.borderRadius
    },
    copyable: {
      icon: {
        size: {
          small: '16px',
          medium: '24px',
          large: '24px'
        },
        right: {
          small: '6.5px !important',
          medium: '7px !important',
          large: '11.5px !important'
        }
      },
      button: {
        width: {
          small: '30px',
          medium: '40px',
          large: '50px'
        },
        height: {
          small: '30px',
          medium: '40px',
          large: '50px'
        }
      }
    },
    clear: {
      iconSize: 20
    },
    multilineHeight: "calc(35px * 2 - ".concat(input.sizes.medium.paddingVertical, " * 2 - ").concat(border.width, " * 2)"),
    tagBorderColor: tokens.colorPalette.grey6,
    optGroupTitleColor: tokens.color.neutral7,
    optHoverBg: tokens.colorPalette.grey2,
    optSelectBg: tokens.colorPalette.blue1,
    dropdownInnerPadding: '4px 0',
    dropdownLineHeight: '35px',
    dropdownItemPadding: '0 6px 0 10px',
    dropdownItemCheckIconRight: '6px',
    selectedIconSize: {
      small: tokens.select.selectedIconSize.small,
      medium: tokens.select.selectedIconSize.medium,
      large: tokens.select.selectedIconSize.large
    }
  };
  var form = {
    padding: '10px',
    caption: {
      color: text.color
    },
    extra: {
      color: text.color,
      buttonTextWeight: '500'
    },
    label: {
      fontWeight: '500',
      paddingBottom: '5px',
      padding: '0 0 5px 0',
      color: text.color,
      fontSize: tokens.form.label.fontSize
    },
    viewMode: {
      backgroundColor: tokens.color.default2,
      border: "1px solid ".concat(tokens.color.default6),
      fontWeight: '500',
      maxHeight: '300px',
      lineHeight: {
        sm: '0.5em',
        md: '1.25em',
        lg: '1.95em'
      }
    },
    error: {
      color: tokens.color.danger6,
      lineHeight: '1.5em',
      fontSize: tokens.font.sizeSm,
      padding: '5px 0 0 0'
    }
  };
  var table = {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: tokens.color.default6,
    borderRadius: '0px',
    paddingVertical: '8px',
    paddingHorizontal: '10px',
    backgroundColor: '#fff',
    fontSize: "".concat(parseInt(tokens.font.size) - 1, "px"),
    middle: {
      paddingVertical: '6px',
      paddingHorizontal: '7px',
      fontSize: tokens.font.sizeSm
    },
    small: {
      paddingVertical: '4px',
      paddingHorizontal: '5px',
      fontSize: tokens.font.sizeSm,
      editable: {
        paddingVertical: '3px',
        paddingHorizontal: '3px'
      },
      input: {
        iconSize: '20px'
      }
    },
    header: {
      color: text.color,
      fontWeight: '500',
      fontSize: "".concat(parseInt(tokens.font.size) - 1, "px"),
      textAlign: 'left',
      backgroundColor: tokens.color.default1,
      sort: {
        backgroundColor: tokens.color.default1,
        color: text.color,
        hover: {
          color: text.color,
          backgroundColor: tokens.color.default2
        },
        active: {
          color: text.color,
          backgroundColor: tokens.color.default2
        },
        sortedRow: {
          color: text.color,
          backgroundColor: tokens.color.default1
        },
        iconSize: 24,
        iconColor: tokens.color.default6,
        iconHoverColor: tokens.color.default7,
        iconSelectedColor: tokens.color.primary6
      },
      filter: {
        backgroundColor: tokens.color.default1,
        color: text.color,
        hover: {
          backgroundColor: tokens.color.default3
        },
        iconSize: 24,
        iconColor: tokens.color.default6,
        iconHoverColor: tokens.color.default7,
        iconSelectedColor: tokens.color.primary6
      }
    },
    zebra: {
      backgroundColor: tokens.color.default1,
      color: text.color
    },
    row: {
      backgroundColor: tokens.color.neutral1,
      hover: {
        backgroundColor: tokens.color.default2
      },
      selected: {
        color: text.color,
        backgroundColor: tokens.color.primary2,
        borderColor: (0, _index.convertHexToRGBA)(tokens.color.neutral11, 3),
        // rgba(0, 0, 0, 0.03);
        hover: {
          backgroundColor: tokens.color.primary3 // TODO ask to designers
        }
      },
      expender: {
        border: "1px solid ".concat(border.colorBase),
        size: '20px',
        iconSize: '11px',
        iconColor: tokens.color.primary6,
        borderRadius: tokens.borderRadiusBase,
        col: {
          width: '50px',
          small: {
            width: '30px'
          }
        }
      }
    },
    footer: {
      backgroundColor: tokens.color.neutral1,
      color: text.color
    },
    title: (0, _defineProperty2.default)({
      color: text.color,
      fontWeight: '500',
      fontSize: tokens.font.size,
      backgroundColor: tokens.color.neutral1
    }, "color", text.color),
    selection: {
      width: '50px',
      iconSize: '16px',
      iconColor: tokens.color.default6,
      iconHoverColor: tokens.color.default5,
      small: {
        width: '30px'
      },
      selectAll: {
        marginRight: tokens.table.selection.selectAll.marginRight,
        padding: tokens.table.selection.selectAll.padding,
        label: {
          marginRight: tokens.table.selection.selectAll.label.marginRight
        }
      }
    },
    sticky: {
      zIndex: 10,
      shadowColor: shadow.color,
      scrollbarBackground: '',
      scrollbarRadius: '',
      scrollbarActiveBackground: ''
    },
    action: {
      width: '44px',
      // 24 + 10 * 2
      iconSize: 24,
      edit: {
        width: 74
      },
      height: '28px',
      small: {
        width: '30px',
        // 20 + 5 * 2
        iconSize: 20,
        edit: {
          width: 56
        },
        height: '24px'
      }
    },
    draggable: {
      column: {
        icon: {
          hover: {
            backgroundColor: '#dfdfdf'
          },
          width: tokens.table.draggable.column.icon.width
        }
      }
    }
  };
  var tableHeader = {
    button: {
      text: {
        marginLeft: tokens.tableHeader.button.text.marginLeft
      }
    }
  };
  var radio = {
    radioInnerBackgroundColor: '#fff',
    borderColor: tokens.color.default6,
    circleSize: '20px',
    circleDotSize: '12px',
    labelPadding: '8px',
    labelMargin: '12px',
    checkColor: tokens.color.primary6,
    inputHoverBorderColor: tokens.color.primary6,
    inputDisabledBackground: tokens.color.default2,
    textColorDisabled: tokens.color.default6,
    borderRadiusBase: '4px',
    transitionDuration: '0.3s',
    focusBoxShadow: '0 0 3px 3px ' + tokens.color.primary3,
    selectionBox: {
      componentPadding: tokens.component.padding
    },
    label: {
      fontSize: tokens.radio.label.fontSize,
      fontWeight: tokens.radio.label.fontWeight,
      lineHeight: tokens.radio.label.lineHeight
    }
  };
  var checkbox = {
    labelPadding: '8px',
    labelMargin: '12px',
    check: {
      size: '20px',
      indeterminateSize: '10px',
      indeterminateBorderRadius: '2px',
      backgroundColor: '#fff',
      borderRadius: '4px',
      hoverBorderColor: tokens.color.primary6,
      focusBoxShadow: '0 0 3px 3px ' + tokens.color.primary3,
      // todo check this
      status: {
        default: {
          textColor: text.color,
          borderColor: tokens.color.default6,
          iconColor: tokens.color.neutral11,
          backgroundColor: tokens.color.neutral1
        },
        checked: {
          textColor: text.color,
          borderColor: tokens.color.primary6,
          iconColor: tokens.color.primary6,
          backgroundColor: tokens.color.neutral1
        },
        disabled: {
          textColor: text.colorDisabled,
          borderColor: tokens.color.default6,
          iconColor: tokens.color.default6,
          backgroundColor: tokens.color.default2,
          indeterminateColor: tokens.color.default6
        }
      }
    },
    label: {
      fontSize: tokens.checkbox.label.fontSize,
      fontWeight: tokens.checkbox.label.fontWeight,
      lineHeight: tokens.checkbox.label.lineHeight
    }
  };
  var carousel = {
    navIcons: {
      arrowSize: 24,
      arrowColor: tokens.colorPalette.grey6,
      arrowButtonPadding: '5px',
      arrowContentSpace: 10,
      dotSize: '8px',
      dotPadding: '5px',
      dotColor: tokens.color.default4,
      dotActiveColor: tokens.color.primary6
    }
  };
  var tree = {
    containerPadding: '5px',
    containerMargin: '0px',
    toggleIcon: {
      width: '16px',
      height: '16px',
      lineHeight: '16px',
      iconWidth: '5px',
      iconColor: tokens.colorPalette.grey6
    },
    line: {
      left: '8px',
      color: tokens.colorPalette.grey4
    },
    checkbox: {
      marginRight: '4px',
      marginLeft: '4px',
      width: '16px',
      height: '16px',
      borderRadius: '2px',
      iconHeight: '9px',
      iconWidth: '5px',
      borderColor: tokens.colorPalette.grey6,
      checkedBorderColor: tokens.color.primary6
    },
    customIcon: {
      size: '16px'
    },
    treeItem: {
      margin: 0,
      padding: 0,
      textColor: text.color,
      hoverBackgroundColor: tokens.colorPalette.grey2,
      indentWidth: '20px',
      childTreeMarginBottom: '6px',
      textPadding: '0px 2px',
      fontSize: '14px',
      lineHeight: '1.5',
      disabled: {
        textColor: '#ccc',
        backgroundColor: tokens.colorPalette.grey2,
        checkColor: tokens.colorPalette.grey6
      }
    },
    draggable: {
      target: {
        defaultTextColor: text.color,
        onDragTextColor: tokens.color.neutral1,
        onDragBackgroundColor: tokens.color.primary6,
        onDragBorderColor: '2px solid ' + tokens.color.primary6,
        dragPointerBorder: '2px solid ' + tokens.color.primary6
      },
      source: {
        backgroundColor: tokens.color.primary3,
        border: 'none',
        opacity: '1'
      }
    }
  };
  var datepicker = {
    padding: {
      xs: '4px',
      sm: '8px',
      md: '8px',
      lg: '16px'
    },
    calendarBg: component.background,
    borderColor: tokens.colorPalette.grey6,
    arrowSize: '10px',
    disabledColor: text.colorDisabled,
    textHeight: '32px',
    borderColorSplit: tokens.color.default7,
    panelArrowSize: '7px',
    panelCellWidth: '40px',
    panelYearMonthCellWidth: '80px',
    panelWidth: "calc(40px * 7 + 8px * 2 + 4px)",
    panelHeadingColor: tokens.color.neutral11,
    panelCellHeight: '24px',
    itemHoverBg: tokens.colorPalette.grey1,
    cellActiveWithRangeColor: tokens.colorPalette.blue5,
    textColorInverse: '#fff',
    panelWidthoutTimeCellHeight: '48px',
    linkColor: tokens.color.primary6,
    linkActiveColor: tokens.color.primary7,
    linkHoverColor: tokens.color.neutral5,
    timePanelCellHeight: '24px',
    focusBoxShadow: '0 0 3px 3px ' + tokens.color.primary3,
    clear: {
      iconSize: 20
    }
  };
  var upload = {
    pictureCardSize: '104px',
    pictureCardBorderStyle: border.style,
    backgroundColor: tokens.color.neutral1,
    draggableHoverBorderColor: tokens.color.primary1,
    draggableBorderSize: '12px',
    listItemIconSize: '18px',
    listItemHoverColor: '',
    linkColor: tokens.color.primary6,
    linkHoverColor: tokens.color.primary5,
    infoColor: tokens.color.primary6,
    headingColor: tokens.color.neutral11,
    disabledColor: text.disabledColor,
    // TODO
    errorColor: tokens.color.danger6,
    successColor: tokens.color.success6,
    multipleUpload: {
      height: tokens.upload.multipleUpload.height
    }
  };
  var tag = {
    fontSize: {
      small: '13px',
      default: '13px',
      large: '14px'
    },
    lineHeight: {
      small: '22px',
      default: '28px',
      large: '38px'
    },
    padding: {
      small: '0 8px',
      default: '0 15px',
      large: '0 15px'
    },
    paddingWithIcon: {
      small: '0 6px',
      default: '0 8px',
      large: '0 10px'
    },
    closablePaddingRight: {
      small: '6px',
      default: '8px',
      large: '10px'
    }
  };
  var avatar = {
    color: tokens.color.primary6,
    backgroundColor: tokens.color.neutral3,
    size: {
      xsmall: '24',
      small: '32',
      default: '40',
      large: '48',
      xlarge: '64',
      xxlarge: '80'
    },
    fontSize: {
      xsmall: '11px',
      small: '13px',
      default: '16px',
      large: '18px',
      xlarge: '24px',
      xxlarge: '30px'
    },
    fontWeight: 500,
    circleBorderRadius: '50%',
    squareBorderRadius: '2px',
    group: {
      overlapping: '-16px',
      border: '2px solid white',
      space: '5px'
    }
  };
  var calendar = {
    card: {
      width: tokens.calendar.card.width,
      date: {
        height: tokens.calendar.card.date.height,
        day: {
          height: tokens.calendar.card.date.day.height,
          fontSize: tokens.calendar.card.date.day.fontSize,
          lineHeight: tokens.calendar.card.date.day.lineHeight
        }
      },
      footer: {
        button: {
          width: tokens.calendar.card.footer.button.width,
          marginBottom: tokens.calendar.card.footer.button.marginBottom
        },
        badge: {
          marginLeft: tokens.calendar.card.footer.badge.marginLeft,
          colors: [tokens.colorPalette.blue6, tokens.colorPalette.green6, tokens.colorPalette.cyan6, tokens.colorPalette.orange6, tokens.colorPalette.geekblue6, tokens.colorPalette.gold6, tokens.colorPalette.gray6, tokens.colorPalette.lime6, tokens.colorPalette.magenta6, tokens.colorPalette.purple6, tokens.colorPalette.red6, tokens.colorPalette.volcano6, tokens.colorPalette.yellow6]
        }
      }
    }
  };
  var defaultTokens = {
    mixins: mixins,
    button: button,
    icon: icon,
    text: text,
    divider: divider,
    border: border,
    list: list,
    card: card,
    Switch: Switch,
    animation: animation,
    modal: modal,
    tooltip: tooltip,
    popover: popover,
    progress: progress,
    collapse: collapse,
    spin: spin,
    infoBox: infoBox,
    notification: notification,
    menu: menu,
    input: input,
    textarea: textarea,
    typography: typography,
    pagination: pagination,
    select: select,
    tabs: tabs,
    dropdown: dropdown,
    steps: steps,
    form: form,
    table: table,
    tableHeader: tableHeader,
    component: component,
    radio: radio,
    checkbox: checkbox,
    carousel: carousel,
    datepicker: datepicker,
    upload: upload,
    tree: tree,
    tag: tag,
    avatar: avatar,
    calendar: calendar
  };
  return (0, _ykbUtils.mergeDeep)(defaultTokens, tokens);
};